import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable } from "rxjs";
import { USER_URL } from "../shared/src";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable({
  providedIn: 'root',
})

export class LeaveServiceService {
  private readonly LEAVE_API = `${USER_URL}`;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  public leaveTypeGetAll(
    pageIndex: number,
    pageSize: number,
    searchFilter?: string,
    status?: number,
    countryId?: number
  ): Observable<any> {
    let url = `${this.LEAVE_API}/leaveType/getAll?pageIndex=${pageIndex}&pageSize=${pageSize}`;

    if (searchFilter) {
      url += `&searchFilter=${searchFilter}`;
    }

    if (status !== undefined) {
      url += `&status=${status}`;
    }

    if (countryId) {
      url += `&countryId=${countryId}`;
    }

    return this.http
      .get<any>(url)
      .pipe(catchError(this.errorHandler.handleError));
  }
  /**
 * Sends a POST request to the server to add a new leave type's information.
 * @param LeaveType - The leave type data to be added
 * @returns
 */
  public addLeaveType(LeaveType: {
    id: number,
    name: string,
    status: boolean,
    countryId?: number
  }): Observable<any> {
    return this.http
      .post<any>(`${this.LEAVE_API}/leaveType/save`, LeaveType)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public updateLeaveType(LeaveType: {
    id: number;
    name: string;
    status: boolean;
    countryId?: number;
  }): Observable<any> {
    return this.http
      .put<any>(`${this.LEAVE_API}/leaveType/update`, LeaveType)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public deleteLeaveType(id: number): Observable<string> {
    return this.http
      .delete<string>(`${this.LEAVE_API}/leaveType/delete/${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }
  public updateToggleLeaveStatus(id: number): Observable<any> {
    return this.http
      .put<any>(`${this.LEAVE_API}/leaveType/changeStatus/${id}`, null)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAllActiveStatus(countryId?: number | null): Observable<any> {
    let url = `${this.LEAVE_API}/leaveType/getAllActive`;

    if (countryId) {
      url += `?countryId=${countryId}`;
    }

    return this.http
      .get<any>(url)
      .pipe(catchError(this.errorHandler.handleError));
  }

}